export const getRoute = (state) => state.giving_form.routes.get("currentRoute");
export const getModalState = (state) => state.giving_form.routes.get("isModalOpen");
export const getPreviousPage = (state) => state.giving_form.routes.get("previousPage");
